const MediumSquareIcon = /*#__PURE__*/ [
  ["circle", { cx: "7.5", cy: "12.5", r: "2.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["ellipse", { cx: "13.5", cy: "12.5", rx: "1.5", ry: "2.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["ellipse", { cx: "18", cy: "12.5", rx: "1", ry: "2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { MediumSquareIcon as default };
//# sourceMappingURL=MediumSquareIcon.js.map
